var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/Small/Paused",
    clipPath: "url(#clip0_3470_2572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.5 3.2C3.5 3.08954 3.58954 3 3.7 3H4.8C4.91046 3 5 3.08954 5 3.2V8.8C5 8.91046 4.91046 9 4.8 9H3.7C3.58954 9 3.5 8.91046 3.5 8.8V3.2ZM7 3.2C7 3.08954 7.08954 3 7.2 3H8.3C8.41046 3 8.5 3.08954 8.5 3.2V8.8C8.5 8.91046 8.41046 9 8.3 9H7.2C7.08954 9 7 8.91046 7 8.8V3.2Z",
    fill: "#2B3242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3470_2572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.c21efd08840485aa7544d72c832f8611.svg";
export { ForwardRef as ReactComponent };